// src/components/auth/RegisterBusiness.js
//
// Shown to a signed-in Google account with no business behind it yet
// (role "unregistered" — see server.js's GoogleStrategy verify callback).
// Replaces the old "submit a request and wait for admin approval" flow
// (RequestAccess.js, still used only as a fallback path — see App.js):
// this submits straight to POST /auth/register, which creates the
// business on the free Trial plan immediately and re-points the current
// session token to full manager access — no re-login, no waiting screen.
import React, { useState } from 'react';
import { css } from '../../App';
import * as api from '../../api';

function RegisterBusiness({ user, onRegistered, onLogout }) {
  const [form, setForm] = useState({ businessName: "", businessType: "manufacturing" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.businessName.trim()) {
      setError("Business name is required.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.registerBusiness(form);
      await onRegistered();
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <><style>{css}</style>
      <div className="login-screen">
        <div style={{ background: "#fff", borderRadius: 16, padding: 32, maxWidth: 440, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,.3)", maxHeight: "92vh", overflowY: "auto" }}>
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <div style={{ fontSize: 36 }}>🏪</div>
            <h2 style={{ fontSize: 20, margin: "8px 0 4px", color: "#1a1a2e" }}>Set Up Your Business</h2>
            <p style={{ fontSize: 12, color: "#6b7280" }}>
              Signed in as <strong>{user?.email}</strong>. This takes a few seconds — no approval wait,
              you'll land straight on the free <strong>Trial</strong> plan.
            </p>
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
            <div>
              <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, textTransform: "uppercase", letterSpacing: .4 }}>Business Name *</label>
              <input type="text" value={form.businessName} onChange={e => set("businessName", e.target.value)} placeholder="e.g. Khalid Footwear"
                style={{ width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, color: "#1a1a2e", outline: "none" }} />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, textTransform: "uppercase", letterSpacing: .4 }}>Business Type</label>
              <select value={form.businessType} onChange={e => set("businessType", e.target.value)}
                style={{ width: "100%", padding: "9px 12px", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13, color: "#1a1a2e", outline: "none" }}>
                <option value="manufacturing">Manufacturing (production + orders + walk-in)</option>
                <option value="retail_only">Retail Only (buy and resell, no custom orders)</option>
                <option value="service_only">Service Only (custom orders, no walk-in sales)</option>
                <option value="custom">Custom — you can adjust modules later in Settings</option>
              </select>
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: "100%", marginBottom: 10 }} onClick={submit} disabled={loading}>
            {loading ? "Setting up your workspace…" : "🚀 Create My Business"}
          </button>
          <button className="btn btn-secondary" style={{ width: "100%", fontSize: 12 }} onClick={onLogout}>Sign out</button>
          <p style={{ textAlign: "center", fontSize: 11, color: "#9ca3af", marginTop: 14 }}>
            By continuing you agree to our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: "#9ca3af" }}>Privacy Policy</a>.
          </p>
        </div>
      </div></>
  );
}

export default RegisterBusiness;
